import { createContext, use } from "react";

import type ConstructorIOClient from "@constructor-io/constructorio-client-javascript";

export const CIOClientContext = createContext<
  ConstructorIOClient | null | undefined
>(undefined);

export function useCioClient() {
  return use(CIOClientContext);
}

/**
 * Constructor facet flagging LMN eligibility (TPA-08). The misspelling is
 * canonical — it's the live CIO facet name (verified on FSA dev:
 * `lmn-true` / `lmn-false`). Lives here (isomorphic) so the server loaders
 * AND the client autocomplete share one source of truth for the typo.
 */
export const LMN_CIO_FACET = "LMN-Eligibile";
/** Facet value for non-LMN products — applied to hide LMN from discovery. */
export const LMN_CIO_EXCLUDE_VALUE = "lmn-false";
